import { Component, HostListener, Renderer2, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ConsultClientService } from 'src/app/services/consult-client.service';
import { LogoutService } from 'src/app/services/logout.service';
import { SuggestingService } from 'src/app/services/suggesting.service';
import { WithdrawalDraftStorageService } from 'src/app/services/withdrawal-draft-storage.service';
import { DRAFT_TEMPLATES_ROUTE, DRAFT_TYPE_SELECT_ROUTE, NEW_DRAFT_ACTION } from '../constants';

export const MOBILE_MENU_BODY_CLASS = 'mobile-menu-open';

@Component({
  selector: 'libero-header-consult',
  templateUrl: './header-consult.component.html',
  styleUrl: './header-consult.component.scss',
  standalone: false
})
export class HeaderConsultComponent {
  public mobileMenuVisible = false;
  public draftsDropdownOpen = signal(false);
  public mobileDraftsOpen = signal(false);

  public DRAFT_TEMPLATES_ROUTE = DRAFT_TEMPLATES_ROUTE;

  @HostListener('document:click')
  public onDocumentClick(): void {
    this.draftsDropdownOpen.set(false);
  }

  public constructor(
    private logoutService: LogoutService,
    private renderer: Renderer2,
    private router: Router,
    private suggestingService: SuggestingService,
    private withdrawalDraftStorageService: WithdrawalDraftStorageService,
    public consultClientService: ConsultClientService,
  ) { }

  public openMobileMenu(): void {
    this.mobileMenuVisible = true;
    this.renderer.addClass(document.body, MOBILE_MENU_BODY_CLASS);
  }

  public closeMobileMenu(routeOnClose?: string): void {
    this.renderer.removeClass(document.body, MOBILE_MENU_BODY_CLASS);
    this.mobileDraftsOpen.set(false);
    if(routeOnClose) {
      this.withdrawalDraftStorageService.resetDraft();
      this.consultClientService.resetDraftType();
      this.consultClientService.clearDataAndSetDefault();
      this.router.navigate([routeOnClose]);
    }

    this.mobileMenuVisible = false;
  }

  public logoutConsult(): void {
    this.renderer.removeClass(document.body, MOBILE_MENU_BODY_CLASS);
    this.logoutService.logOut({userType: 'consult'});
    this.mobileMenuVisible = false;
  }

  public toggleDraftsDropdown(event: Event): void {
    event.stopPropagation();
    this.draftsDropdownOpen.update(v => !v);
  }

  public toggleMobileDrafts(): void {
    this.mobileDraftsOpen.update(v => !v);
  }

  public navigate(route: string, $event?: Event): void {
    $event?.stopPropagation();
    this.draftsDropdownOpen.set(false);
    this.mobileDraftsOpen.set(false);
    this.renderer.removeClass(document.body, MOBILE_MENU_BODY_CLASS);
    this.mobileMenuVisible = false;
    this.withdrawalDraftStorageService.resetDraft();
    this.consultClientService.resetDraftType();
    this.consultClientService.clearDataAndSetDefault();

    if (route === NEW_DRAFT_ACTION) {
      this.goToNewDraft();
    } else {
      this.router.navigate([`/${route}`]);
    }
  }

  private goToNewDraft(): void {
    this.renderer.removeClass(document.body, MOBILE_MENU_BODY_CLASS);
    this.suggestingService.resetStepsLimited();
    if (this.router.url.includes(DRAFT_TYPE_SELECT_ROUTE)) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl('/' + DRAFT_TYPE_SELECT_ROUTE);
      });
    } else {
      this.router.navigate([`/${DRAFT_TYPE_SELECT_ROUTE}`]);
    }
    this.mobileMenuVisible = false;
  }
}
